import React from 'react';
import {
  Container,
  Typography,
} from '@mui/material';
import InfiniteReviewsList from '../../components/infinite-reviews-list';

const Reviews = () => (
  <Container
    sx={{
      py: { desktop: 4.5, mobile: 2 },
    }}
  >
    <Typography component="h1" variant="h2" sx={{ marginBottom: 2 }}>
      Reviews
    </Typography>
    <InfiniteReviewsList />
  </Container>
);

export default Reviews;
